import { default as PaymentsRedirectToBank } from 'modules/Payment/components/RedirectToBank';
import { saveNewCardParamsGPb } from 'modules/App/services/API/bank';

export class SaveCardRedirectToBank extends PaymentsRedirectToBank {
  static propTypes = {};

  static defaultProps = {};

  async fetchData() {
    return await saveNewCardParamsGPb();
  }
}
